export class HierarchyPath {
    public id: number;
    public name: string;
    public parent: HierarchyPath;
    public creationTimestamp: Date | string;
    public createdBy: string;

    public parse(obj: any) {
        if (obj.Id != null) this.id = obj.Id;
        if (obj.Name != null) this.name = obj.Name;
        // Todo parent?
        if (obj.CreationTimestamp) this.creationTimestamp = obj.CreationTimestamp;
        if (obj.CreatedBy) this.createdBy = obj.CreatedBy;
    }
}
